module.exports = __webpack_public_path__ + "img/07.95af8127.jpg";